import React, { useEffect, useState, useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";

export default function Glossary() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [params] = useSearchParams();
  const [cat, setCat] = useState(params.get("cat") || "all");

  useEffect(() => { api.get("/glossary").then(r => setItems(r.data.terms)); }, []);

  const cats = useMemo(() => Array.from(new Set(items.map(i => i.category))), [items]);
  const filtered = items.filter(i =>
    (cat === "all" || i.category.toLowerCase() === cat.toLowerCase()) &&
    (q === "" || i.term.toLowerCase().includes(q.toLowerCase()) || i.definition.toLowerCase().includes(q.toLowerCase()))
  );

  return (
    <div data-testid="page-glossary">
      <section className="border-b border-slate-200">
        <div className="container-rp py-16 lg:py-24">
          <div className="overline">Risk Glossary · Singapore</div>
          <h1 className="font-display text-5xl lg:text-6xl font-bold mt-3 tracking-tight">The vocabulary.</h1>
          <p className="text-slate-600 mt-4 max-w-2xl text-lg">Curated definitions across ERM, cyber, financial, operational, AI risk and Singapore-specific terminology.</p>
        </div>
      </section>

      <section className="border-b border-slate-200 bg-slate-50">
        <div className="container-rp py-5 flex flex-wrap items-center gap-3">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search terms..." className="flex-1 min-w-[200px] border border-slate-200 rounded-sm px-4 py-2 text-sm bg-white" data-testid="glossary-search" />
          <button onClick={() => setCat("all")} data-active={cat === "all"} className="persona-btn">All</button>
          {cats.map(c => (
            <button key={c} onClick={() => setCat(c)} data-active={cat === c} className="persona-btn">{c}</button>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="container-rp">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
            {filtered.map(g => (
              <div key={g.slug} className="bg-white p-6" data-testid={`glossary-${g.slug}`}>
                <div className="overline-muted">{g.category}</div>
                <div className="font-display text-lg font-semibold mt-2">{g.term}</div>
                <p className="text-sm text-slate-600 mt-3 leading-relaxed">{g.definition}</p>
              </div>
            ))}
          </div>
          {filtered.length === 0 && <div className="text-center py-16 text-slate-400 text-sm">No matching terms.</div>}
        </div>
      </section>
    </div>
  );
}
